import React from 'react';
import type { FC } from 'react';

import styles from './OnboardingLayout.module.scss';

export type OnboardingLayoutProps = {
  header?: React.JSX.Element;
  content: React.JSX.Element;
  footer?: React.JSX.Element;
};

const OnboardingLayout: FC<OnboardingLayoutProps> = ({ header, content, footer }: OnboardingLayoutProps) => {
  return (
    <div className={styles.container}>
      {header && <header className={styles.headerContainer}>{header}</header>}
      <main className={styles.mainContainer}>{content}</main>
      {footer && <footer className={styles.footerContainer}>{footer}</footer>}
    </div>
  );
};

export default OnboardingLayout;
